import * as React from 'react';
import { PrismLight as SyntaxHighlighter, SyntaxHighlighterProps } from 'react-syntax-highlighter';
import { base16AteliersulphurpoolLight as prismStyle } from 'react-syntax-highlighter/dist/esm/styles/prism';
import sql from 'react-syntax-highlighter/dist/cjs/languages/prism/sql';
import python from 'react-syntax-highlighter/dist/cjs/languages/prism/python';
import jsx from 'react-syntax-highlighter/dist/cjs/languages/prism/jsx';
import tsx from 'react-syntax-highlighter/dist/cjs/languages/prism/tsx';
import typescript from 'react-syntax-highlighter/dist/cjs/languages/prism/typescript';
import json from 'react-syntax-highlighter/dist/cjs/languages/prism/json';
import bash from 'react-syntax-highlighter/dist/cjs/languages/prism/bash';
import powershell from 'react-syntax-highlighter/dist/cjs/languages/prism/powershell';
import { fontFamilies } from '../theme/text';
import { makeStyles } from '@material-ui/core';

SyntaxHighlighter.registerLanguage('sql', sql);
SyntaxHighlighter.registerLanguage('python', python);
SyntaxHighlighter.registerLanguage('jsx', jsx);
SyntaxHighlighter.registerLanguage('tsx', tsx);
SyntaxHighlighter.registerLanguage('typescript', typescript);
SyntaxHighlighter.registerLanguage('json', json);
SyntaxHighlighter.registerLanguage('bash', bash);
SyntaxHighlighter.registerLanguage('powershell', powershell);

export interface CodeBlockProps extends SyntaxHighlighterProps {
  /** The content of the code block. Leading and trailing whitespace will be trimmed. */
  code: string;
  /** One of the registered languages: currently `sql`, `python`, `jsx`, `tsx`, `typescript`, `json`, `bash`, `powershell`. Many more available if needed. */
  language: string;
}

const useStyles = makeStyles({
  code: {
    fontFamily: fontFamilies.code
  }
});

/**
 * A wrapper for react-syntax-highlighter with default styles importing only
 * necessary languages and styles. At its core, uses prismjs for syntax
 * highlighting and refractor for virtual DOM support. See
 * https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * for all possible props to be forwarded to the highlighter.
 */
function CodeBlock({ code, ...args }: CodeBlockProps) {
  const classes = useStyles();
  const customStyle: React.CSSProperties = {
    fontFamily: fontFamilies.code,
    fontSize: '14px'
  };
  const lineNumberStyle: React.CSSProperties = {
    fontFamily: fontFamilies.code,
    minWidth: '2em'
  };
  return (
    <SyntaxHighlighter
      style={prismStyle}
      customStyle={customStyle}
      lineNumberStyle={lineNumberStyle}
      codeTagProps={{ className: classes.code }}
      {...args}
    >
      {code.trim()}
    </SyntaxHighlighter>
  );
}

export default CodeBlock;
